import FAQ from "../pages/FAQ";
import MemoryGameInfo from "../pages/MemoryGameInfo";
import VariableGameLevelSelect from "../pages/VariableGameLevelSelect";

const content = [
  { title: "Collision Simulator", componenet: null, path: "/simulator" },
  { title: "FAQ", component: <FAQ /> },
  { title: "Memory Game", component: <MemoryGameInfo /> },
  { title: "Variable Game", component: <VariableGameLevelSelect /> },
];

export default content;
